"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINAL_FRAGMENT_TYPES = void 0;
exports.isFinalFragmentType = isFinalFragmentType;
exports.FINAL_FRAGMENT_TYPES = new Set(['packageUnderstanding']);
function isFinalFragmentType(name) {
    return exports.FINAL_FRAGMENT_TYPES.has(name);
}
//# sourceMappingURL=fragment-types.js.map